import { freddyTheme as theme } from '@coolblue-development/freddy';
export const getColorPickerItemStyles = (isLastVisible) => ({
    position: 'relative',
    ...(isLastVisible && {
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            borderRadius: '4px',
            cursor: 'pointer',
        },
    }),
});
export const overlayTextStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.color.font.inverseBase,
    fontWeight: theme.typography.h2.fontWeight,
    fontSize: theme.typography.fontSize['3xl'],
    zIndex: 2,
    cursor: 'pointer',
};
//# sourceMappingURL=ColorPicker.styles.js.map